export enum EModalSectionMode {
  EDIT = 'EDIT',
  CREATE = 'CREATE'
}
